import React from 'react';
import { Box, Paper, Typography, Grid } from '@mui/material';

const StatCard = ({ label, value }) => (
  <Paper
    sx={{
      p: 2,
      textAlign: 'center',
      border: 1,
      borderColor: 'divider',
      bgcolor: 'transparent',
    }}
  >
    <Typography variant="h5" fontWeight="bold">
      {value ?? '-'}
    </Typography>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
  </Paper>
);

const WallLogbookStats = ({ stats }) => {
  if (!stats) return null;

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={6} sm={4} md={2}>
        <StatCard label="Ripetizioni" value={stats.totalClimbs} />
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <StatCard label="Vie attive" value={stats.activeClimbs} />
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <StatCard label="Vie rimosse" value={stats.archivedClimbs} />
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <StatCard label="Grado max" value={stats.hardestGrade} />
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <StatCard label="Media grado" value={stats.averageGrade} />
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <StatCard label="Media bellezza" value={stats.averageRating || '-'} />
      </Grid>
    </Grid>
  );
};

export default WallLogbookStats;
